import { useLingui } from '@lingui/react/macro';
import React from 'react';
import { getSymbolicTeamRankLabel } from 'modules/championship/domain/constants/symbolic-team-rank-labels';
import { SymbolicTeamFormation } from 'modules/championship/domain/enums/symbolic-team-formation';
import { PlayerRankContainer, PlayerRankWrapper } from './player-rank.styles';

type PlayerRankProps = {
  className?: string;
  formation: SymbolicTeamFormation;
  rank: number;
};

export const PlayerRank = ({ className, formation, rank }: PlayerRankProps) => {
  const { t } = useLingui();
  const label = getSymbolicTeamRankLabel(formation, rank);

  return (
    <PlayerRankWrapper className={className}>
      <PlayerRankContainer className="text footnote">{label ? t(label) : rank}</PlayerRankContainer>
    </PlayerRankWrapper>
  );
};
